(function () {
  'use strict';

  angular.module('app').component('exchangeRateDetail', exchangeRateDetail());

  function exchangeRateDetail() {
    return {
      bindings: {
        item: '=',
        companyId: '<',
        companyBaseCurrency: '<',
        currency: '<',
        onExchangeRateSaved: '&',
        onExchangeRateCancelled: '&',
      },
      controller: ExchangeRateDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/exchange-rates/exchange-rate-detail/exchange-rate-detail.component.html',
    };
  }

  ExchangeRateDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'moment',
    'ExchangeRateService',
  ];

  function ExchangeRateDetailComponent(config, UtilService, moment, ExchangeRateService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;

    vm.$onInit = function () {
      setDatePickerOptions();

      // console.log(vm.item);
      // console.log(vm.currency);

      if (vm.item.id) {
        // edit
        vm.item.from = moment(vm.item.from);
        vm.item.to = moment(vm.item.to);

        vm.optionsTo.minDate = moment(vm.item.from);
      } else {
        // create
        vm.createMode = true;

        vm.item = {
          from: '',
          to: '',
          currency_id: vm.currency.id,
          isLastExchangeRate: true,
        };

        if (vm.currency.lastExchangeRate) {
          let currencyLastExchangeRate = vm.currency.lastExchangeRate;

          vm.item.from = moment(currencyLastExchangeRate.to).add(1, 'days');
          vm.optionsTo.minDate = moment(currencyLastExchangeRate.to).add(2, 'days');
        }

        /*if (vm.currency.exchange_rates.length > 0) {
                    let currencyLastExchangeRate = vm.currency.exchange_rates[vm.currency.exchange_rates.length - 1];

                    vm.item.from         = moment(currencyLastExchangeRate.to).add(1, 'days');
                    vm.optionsTo.minDate = moment(currencyLastExchangeRate.to).add(2, 'days');
                }*/
      }

      /*if (vm.currency.exchange_rates.length > 0) {
                vm.currencyHasExchangeRates = true;
            }*/
    };

    // public methods
    // -----------------------
    // Create/Update
    vm.saveExchangeRate = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        return;
      }

      vm.sendingForm = true;
      ExchangeRateService.saveExchangeRate(vm.item).then(function (data) {
        var status = data.status;
        var response = data.response;

        if (status) {
          // success
          vm.item = response;
          vm.onExchangeRateSaved({ item: response });
        } else {
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    };

    vm.cancel = function () {
      vm.onExchangeRateCancelled();
    };

    // private methods
    // -----------------------
    function setDatePickerOptions() {
      vm.optionsFrom = {
        singleDatePicker: true,
        showDropdowns: true,
        minDate: moment(),
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'apply.daterangepicker': function applyDateRangePicker() {
            vm.optionsTo.minDate = angular.copy(vm.item.from).add(1, 'days');

            if (vm.item.to && vm.item.to <= vm.item.from) {
              vm.item.to = vm.optionsTo.minDate;
            }
          },
        },
      };

      vm.optionsTo = {
        singleDatePicker: true,
        showDropdowns: true,
        minDate: moment().add(1, 'days'),
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'apply.daterangepicker': function applyDateRangePicker() {
            vm.optionsFrom.maxDate = vm.item.to;
          },
        },
      };
    }
  }
})();
